import React from "react";
import { ChevronDown } from "lucide-react";
import { Link } from "react-router-dom";

const HeroSection = () => {
  const scrollToPhilosophy = () => {
    const element = document.getElementById("philosophy");

    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      className="relative h-screen flex items-center justify-center overflow-hidden"
      aria-label="Bond Boxing introduction"
    >
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://i.imgur.com/nZlamyN.jpeg"
          alt=""
          aria-hidden="true"
          width="1920"
          height="1080"
          fetchPriority="high"
          decoding="async"
          className="w-full h-full object-cover"
        />

        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black"></div>
      </div>

      {/* Hero Content */}
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">

        {/* Main SEO Heading */}
        <h1 className="text-4xl sm:text-6xl md:text-9xl font-bold text-white mb-6 sm:mb-6 tracking-wider outlined-text leading-tight animate-fade-in">
          <span className="block">BOND</span>
          <span className="block">BOXING</span>
        </h1>

        {/* Location and Service Description */}
        <p className="text-white text-sm sm:text-lg tracking-wide mb-8 animate-fade-in-delay">
          Boxing Gym & Fitness Training in Gaborone, Botswana
        </p>

        {/* Calls to Action */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-fade-in-delay-3">

          <Link
            to="/contact"
            className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 font-semibold tracking-wide transition-all duration-300 border border-red-600 hover:border-red-700 hover:shadow-lg hover:shadow-red-600/50 hover:scale-105"
          >
            Join The Ranks
          </Link>

          <button
            type="button"
            onClick={scrollToPhilosophy}
            className="border-2 border-white text-white hover:bg-white hover:text-black px-8 py-4 font-semibold tracking-wide transition-all duration-300 flex items-center gap-2 hover:scale-105"
          >
            <span aria-hidden="true">▶</span>
            The Mission
          </button>

        </div>
      </div>

      {/* Scroll Indicator */}
      <button
        type="button"
        onClick={scrollToPhilosophy}
        aria-label="Scroll to learn about our philosophy"
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce cursor-pointer z-10 hover:text-red-500 transition-colors duration-300"
      >
        <ChevronDown size={40} aria-hidden="true" />
      </button>

    </section>
  );
};

export default HeroSection;